import React, { useEffect, useState } from "react";
import { FaSearch, FaRegBuilding } from "react-icons/fa";
import apiClient from "../api.js";
import { Link, useLocation } from "react-router-dom";
import { FaLocationDot, FaIndianRupeeSign } from "react-icons/fa6";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Navigation, Autoplay } from "swiper/modules";
import "swiper/css/bundle";
import Popup from "../components/Popup.jsx";
import Canonical from "../components/Canonical.js";
import Testimonial from "../components/Testimonial.jsx";
// import BuilderSlider from "../components/BuilderSlider.jsx";
import WhyChooseUs from "../components/WhyChooseUs.jsx";
import PlotBuilderSlider from "../components/PlotBuilderSlider.jsx";

const Plot = () => {
  const [name, setname] = useState("");
  const [areaDefault, setAreaDefault] = useState(false);
  const [results, setResults] = useState([]);
  const [regionProperty, setregionProperty] = useState([]);
  const [discountedProperty, setdiscountedProperty] = useState([]);
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const isPlotPage = location.pathname === "/plot";
  const baseText = " Location, Property, Developer... ";
  const [placeholder, setPlaceholder] = useState(baseText);

  useEffect(() => {
    const interval = setInterval(() => {
      setPlaceholder((prev) => prev.slice(1) + prev[0]);
    }, 200); // Speed of running text
    return () => clearInterval(interval);
  }, []);

  useEffect(
    (area) => {
      getArea(area);
      getPropertyDiscountedDeal();
      const delayDebounceFn = setTimeout(() => {
        if (name) {
          fetchSearchResults(name);
        } else {
          setResults([]); // Clear results if name is empty
        }
      }, 300); // 300ms debounce

      return () => clearTimeout(delayDebounceFn);
    },
    [name],
  );

  const fetchSearchResults = async (term) => {
    setLoading(true);
    console.log(mainPlotRegion);
    try {
      if (mainPlotRegion === "") {
        const response = await apiClient.post("plot/search", {
          name: term,
          location: "Mumbai",
        });
        const properties = response.data;
        setResults(properties);
        console.log(properties);
      } else {
        const response = await apiClient.post("plot/search", {
          name: term,
          location: mainPlotRegion,
        });
        const properties = response.data;
        setResults(properties);
        console.log(properties);
      }
    } catch (error) {
      console.error("Error fetching search results:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    setname(e.target.value);
  };

  const getPropertyByRegion = async (area) => {
    try {
      // console.log(area);

      if (areaDefault === false) {
        const area = "Mumbai";
        const response = await apiClient.get(
          `plot/getplotsbyarea/${encodeURIComponent(area)}`,
        );
        setregionProperty(response.data);
        // console.log(response.data);
      } else {
        const response = await apiClient.get(
          `plot/getplotsbyarea/${encodeURIComponent(area)}`,
        );
        setregionProperty(response.data);
        // console.log(response.data);
      }
    } catch (error) {
      console.error("Error fetching search results:", error);
    } finally {
      setLoading(false);
    }
  };

  const areas = [
    "Mumbai",
    "Goa",
    "Raipur",
    "Indore",
    "Gujarat",
    "Vrindavan",
    "Nagpur",
    "Ayodhya",
    "Shimla",
    "Pune",
  ];

  const [activeArea, setActiveArea] = useState(areas[0]);

  useEffect(() => {
    getArea(areas[0]);
  }, []);

  const getArea = async (area) => {
    setActiveArea(area);
    setLoading(true);
    setAreaDefault(true);
    getPropertyByRegion(area);
  };

  const getPropertyDiscountedDeal = async (area) => {
    try {
      const responseDiscounted = await apiClient.get(`plot/discountedproperty`);
      if (responseDiscounted) {
        setdiscountedProperty(responseDiscounted.data);
        // console.log(responseDiscounted.data);
        // console.log(discountedProperty);
      }
    } catch (error) {
      console.error("Error fetching search results:", error);
    } finally {
      setLoading(false);
    }
  };

  // handle popup button
  const [popupData, setPopupData] = useState("");

  const handleButtonClick = (dataName) => {
    // console.log(dataName);
    setPopupData(dataName);
  };

  const [mainPlotRegion, setMainPlotRegion] = useState("");

  const handleCityChange = (e) => {
    if (e.target.value === "pune") {
      setMainPlotRegion("Pune");
    } else if (e.target.value === "goa") {
      setMainPlotRegion("Goa");
    } else if (e.target.value === "raipur") {
      setMainPlotRegion("Raipur");
    } else if (e.target.value === "indore") {
      setMainPlotRegion("Indore");
    } else if (e.target.value === "vrindavan") {
      setMainPlotRegion("Vrindavan");
    } else if (e.target.value === "nagpur") {
      setMainPlotRegion("Nagpur");
    } else if (e.target.value === "ayodhya") {
      setMainPlotRegion("Ayodhya");
    } else if (e.target.value === "shimla") {
      setMainPlotRegion("Shimla");
    } else {
      setMainPlotRegion("Mumbai");
    }
    // If you want to handle Mumbai, you can add logic here
  };

  // const getDisplaySubregion = (subregion) => {
  //   if (subregion === "Dombivali") return "Dombivli";
  //   else if (subregion === "Vikroli") return "Vikhroli";
  //   else if (subregion === "Vadala") return "Wadala";
  //   else return subregion;
  // };

  const canonicalUrl = "https://homesdekho.com/plot";
  const hrfLangTag = "https://homesdekho.com/plot";
  const title = "Buy Plots Across India with HomesDekho";
  const description =
    "Affordable prices, verified listings, prime locations, and a seamless search experience to help you find the right plot anywhere in India.";

  const subregionLink = (() => {
    // If `regionProperty` is an array of properties, prefer the first property that has a subregion
    if (Array.isArray(regionProperty) && regionProperty.length > 0) {
      const firstWith = regionProperty.find((p) => p && p.subregion);
      if (firstWith && firstWith.subregion) {
        return firstWith.subregion.replace(/\s+/g, "-");
      }
    }

    // If `regionProperty` is an object mapping subregion -> properties (like in `Home.jsx`), use the first key
    if (
      regionProperty &&
      typeof regionProperty === "object" &&
      !Array.isArray(regionProperty)
    ) {
      const keys = Object.keys(regionProperty);
      if (keys.length > 0) return keys[0].replace(/\s+/g, "-");
    }

    // Fallback to `activeArea` (normalized) or a sensible default
    return String(activeArea || "Mumbai").replace(/\s+/g, "-");
  })();

  return (
    <>
      <Canonical
        canonicalUrl={canonicalUrl}
        title={title}
        hrfLang={hrfLangTag}
        description={description}
      />
      <section className="banner-img">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div className="input-wrapper-top margin-search-bar">
                <div
                  className={`active-input-type-residentials ${
                    isPlotPage ? "" : "active-input-type-residential"
                  }`}
                >
                  <Link to="/">Residential / Commercial</Link>
                </div>
                <div
                  className={`active-input-type-plotss ${
                    isPlotPage ? "active-input-type-plots" : ""
                  }`}
                >
                  <Link to="/plot">Plots</Link>
                </div>
              </div>
              <div className="input-wrapper text-center">
                <select
                  className="select-city"
                  aria-label="Default select example"
                  onChange={handleCityChange}
                  defaultValue="mumbai"
                >
                  <option value="mumbai">Mumbai</option>
                  <option value="goa">Goa</option>
                  <option value="raipur">Raipur</option>
                  <option value="indore">Indore</option>
                  <option value="vrindavan">Vrindavan</option>
                  <option value="gujarat">Gujarat</option>
                  <option value="nagpur">Nagpur</option>
                  <option value="ayodhya">Ayodhya</option>
                  <option value="shimla">Shimla</option>
                  <option value="pune">Pune</option>
                </select>

                <FaSearch className="search-icon" />
                <input
                  value={name}
                  onChange={handleChange}
                  id="searchPropertyInput"
                  className="search-input"
                  placeholder={placeholder}
                />
                <button onClick={fetchSearchResults} className="search-btn">
                  Search
                </button>
              </div>
              <div
                className="col-md-"
                style={
                  loading === false ? { display: "block" } : { display: "none" }
                }
              >
                {loading && <p className="text-center">Loading...</p>}

                <div className="search-result-div">
                  {results.map((result) => {
                    return (
                      <>
                        <Link
                          className="search-link"
                          to={`property-detail/${result.slug}`}
                        >
                          <div
                            key={result._id}
                            className="inner-search-result-div"
                          >
                            <div className="building-icon-div">
                              <FaRegBuilding className="building-icon" />
                            </div>
                            <div className="project-name-div">
                              <p className="project-name-real">{result.name}</p>{" "}
                              <p className="project-name-txt">Project Name</p>
                            </div>
                          </div>
                        </Link>
                        ;
                      </>
                    );
                  })}
                </div>
              </div>
            </div>
            <div className="col-md-6 d-none d-md-block">
              <div className="banner-txt-div">
                <div>
                  <h1 className="banner-heading">
                    Find Your Perfect <span>Plot</span> With{" "}
                    <span>Homes Dekho</span>
                  </h1>
                  <p className="banner-subheading">
                    Take the next step to own land anywhere in India -
                    affordable, flexible, and future-ready. Explore plots in
                    prime locations with excellent connectivity and strong
                    investment potential. Discover verified plot listings on the
                    trusted HomesDekho real estate portal.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="main-region-section mt-5">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h2 className="banner-heading-h2">
                Explore Properties by Location
              </h2>
              <Swiper
                className="region-button"
                spaceBetween={10} // Space between slides
                slidesPerView={"auto"} // Force 8 slides to fit within the first view
                modules={[FreeMode, Navigation]}
                navigation={true}
                style={{
                  padding: "10px 0px", // Padding around text
                }}
              >
                {areas.map((area, index) => (
                  <SwiperSlide
                    key={area}
                    className="area-name-slider"
                    onClick={() => getArea(area)}
                    style={{
                      display: "inline-flex",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "200px",
                      padding: "10px 20px", // Padding around text
                      background: area === activeArea ? "#032B5F" : "#ffffff", // Highlight the first slide
                      color: area === activeArea ? "#FFFFFF" : "#000000",
                      border: "1px solid #032B5F",
                      borderRadius: "20px", // Rounded corners
                      whiteSpace: "nowrap", // Prevent text wrapping
                      flexShrink: 0, // Prevent slides from shrinking
                    }}
                  >
                    <div>{area}</div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
        </div>
      </section>
      {/* region vise porperty */}
      <section>
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="region-button">
                <div>
                  <div className="hoomepage-region-main-div">
                    <div className="region-name-div-for-homepage">
                      <p className="regiona-name-txt">
                        Plots In{" "}
                        {Array.isArray(regionProperty) &&
                        regionProperty.length > 0
                          ? regionProperty[0].location
                          : ""}
                      </p>
                    </div>
                    <div className="top-projects-div">
                      <p className="top-projects-txt">
                        Top Projects In {subregionLink}
                      </p>
                    </div>
                    <div className="row">
                      <Swiper
                        className="region-button"
                        spaceBetween={10} // Space between slides
                        modules={[FreeMode, Autoplay]}
                        autoplay={{
                          delay: 2000, // Delay between slides in milliseconds (e.g., 2 seconds)
                          disableOnInteraction: false, // Allow autoplay to continue even after user interaction
                        }}
                        style={{ padding: "10px 10px" }}
                        breakpoints={{
                          425: {
                            slidesPerView: 1, // Show 2 slides on small screens
                            spaceBetween: 10,
                          },
                          768: {
                            slidesPerView: 2, // Show 4 slides on tablets
                            spaceBetween: 15,
                          },
                          1024: {
                            slidesPerView: 3, // Show based on content on larger screens
                            spaceBetween: 20,
                          },
                        }}
                      >
                        {Array.isArray(regionProperty) &&
                          regionProperty.slice(0, 3).map((property, index) => (
                            <div className="col-md-12">
                              <SwiperSlide key={index}>
                                <Link
                                  to={`/plot/property-detail/${property.slug}`}
                                  className="property-region-link"
                                >
                                  <div className="homepage-property-main-div">
                                    <div>
                                      <img
                                        className="img-fluid property-img-region"
                                        src={property.imageUrls}
                                        alt={property.name}
                                      />
                                      <p className="property-name-txt-inner-for-regions">
                                        {property.name}
                                      </p>

                                      <p className="property-name-txt-inner-for-region">
                                        {property.BHK &&
                                        Array.isArray(property.BHK) ? (
                                          property.BHK.map((bhk, idx) => (
                                            <span key={idx}>
                                              {bhk}
                                              {idx < property.BHK.length - 1 &&
                                                ", "}
                                            </span>
                                          ))
                                        ) : (
                                          <span>Loading data...</span>
                                        )}{" "}
                                      </p>
                                      <p className="property-price-range-region-vise">
                                        {property.price}
                                      </p>
                                    </div>
                                  </div>
                                </Link>
                              </SwiperSlide>
                            </div>
                          ))}
                      </Swiper>
                      <p className="view-more-link-by-subregion">
                        <Link
                          to={`allplots/${encodeURIComponent(subregionLink)}`}
                        >
                          View more plots
                        </Link>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* region vise porperty  */}

      {/* discounted deals  */}
      <section>
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <p className="subheading-txt">Discounted Deals</p>
            </div>
            <Swiper
              className="region-button"
              spaceBetween={10} // Space between slides
              modules={[FreeMode, Autoplay, Navigation]}
              navigation={true}
              autoplay={{
                delay: 2000, // Delay between slides in milliseconds (e.g., 3 seconds)
                disableOnInteraction: false, // Allow autoplay to continue even after user interaction
              }}
              style={{ padding: "10px 10px" }}
              breakpoints={{
                425: {
                  slidesPerView: 1, // Show 2 slides on small screens
                  spaceBetween: 10,
                },
                768: {
                  slidesPerView: 2, // Show 4 slides on tablets
                  spaceBetween: 15,
                },
                1024: {
                  slidesPerView: 3, // Show based on content on larger screens
                  spaceBetween: 20,
                },
              }}
            >
              {Array.isArray(discountedProperty) &&
                discountedProperty.map((discountedProperty, index) => (
                  <div className="col-md-12">
                    <SwiperSlide key={index}>
                      <div className="discounted-deal-property-div">
                        <Link
                          to={`/plot/property-detail/${discountedProperty.slug}`}
                          className="view-detail-btn-property-home-txt"
                        >
                          <img
                            src={discountedProperty.imageUrls}
                            className="discounted-property-img img-fluid "
                            alt={`Discounted property ${discountedProperty.name}`}
                          />
                        </Link>
                        <div className="disocunted-property-specs-div">
                          <p className="discounted-property-name">
                            <Link
                              to={`/plot/property-detail/${discountedProperty.slug}`}
                              className="view-detail-btn-property-home-txt"
                            >
                              {discountedProperty.name}
                            </Link>
                          </p>
                          <p className="discounted-property-address-txt">
                            <FaLocationDot />
                            <span>{discountedProperty.address}</span>
                          </p>
                          <p className="discounted-property-price">
                            <FaIndianRupeeSign />
                            <span>{discountedProperty.price}</span>
                          </p>
                          <div className="property-devloper-btn-home-div">
                            <Link
                              to={`/plot/property-detail/${discountedProperty.slug}`}
                              className="view-detail-btn-property-home"
                            >
                              View Details
                            </Link>
                            <button
                              type="button"
                              data-bs-toggle="modal"
                              data-bs-target="#staticBackdrop"
                              className="get-call-btn-property-home-page"
                              onClick={() =>
                                handleButtonClick(discountedProperty.name)
                              }
                            >
                              Enquire Now
                            </button>
                          </div>
                        </div>
                      </div>
                    </SwiperSlide>
                  </div>
                ))}
            </Swiper>
          </div>
        </div>
      </section>
      {/* discounted deals  */}
      {/* Why choose us section  */}
      <WhyChooseUs />
      {/* Why choose us section  */}

      {/* developer section auto scroll  */}
      <section>
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <p className="subheading-txt">Top Builders in Mumbai</p>
            </div>
            <PlotBuilderSlider />
          </div>
        </div>
      </section>
      {/* developer section auto scroll  */}
      {/* Review Section  */}
      <Testimonial />
      <Popup data={popupData} />
    </>
  );
};

export default Plot;
